// extracted by mini-css-extract-plugin
export default {"zoomModal":"WZ-z"};